import styles from "./Statement.module.css";
import PagesWrapper from "../mainpage/PagesWrapper";
import { Section } from "../../../types";

const Statement = ({
  data,
  bgData,
}: {
  data: Section[];
  bgData: Section[];
}) => {
  return (
    <PagesWrapper
      data={bgData}
      header={"Artist Statement"}
      header2={"uwe.s (Uwe Scheutzel)"}
      header3={"LICHTBILDER"}
      image={"./media/044_Portraet_Q.jpg"}
    >
      {data[0] &&
        data[0].texts[0] &&
        data[0].texts[0].content.split("\n").map((v, i) => (
          <p key={i} className={styles.text}>
            {v}
          </p>
        ))}
    </PagesWrapper>
  );
};

export default Statement;
